export enum TimeSheetStatusEnum {
	// time sheet has not been started by pilot (though there may be imported flights from CMS)
	NotStarted = 0,

	// has been submitted by pilot for approval by admin
	SubmittedByEmployee = 1,

	// has been approved by the admin and is ready to be exported
	ApprovedByAdmin = 2,

	// has been exported to workday
	Paid = 3,

	// has been started
	InProgress = 4
}
